export const isAdmin = state => state.admin || false

export const isImpersonating = state =>
  state.impersonatingId !== null && state.id !== state.impersonatingId



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/store/currentUser/currentUser.selectors.js